import { getPath } from '@/router/common'

const baseUrl = {
  title: '自助提货',
  path: 'selfPickup'
}

export default [
  {
    path: getPath('index', baseUrl),
    name: 'selfPickupIndex',
    component: () => import(/* webpackChunkName: "selfPickupIndex" */ '@/views/selfPickup/index.vue'),
    meta: {
      title: '自助提货'
    }
  },
  {
    path: getPath('detail', baseUrl),
    name: 'selfPickupDetail',
    component: () => import(/* webpackChunkName: "selfPickupDetail" */ '@/views/selfPickup/unitDetail.vue'),
    meta: {
      title: '运单详情'
    }
  }
]
